export default "/assets/images/smiling-girl-placeholder.568f2b0f67ff4aba.webp";